$.fn.slideSelectorMenu = function() {
  let self = this

  self.addClass("slide-selector-menu");

  var selector = $( '<div class="slide-selector-menu__selector"></div>' )

  self.append(selector);

  self.find( "> li" ).hover(function() {
    selector.css('left', $(this).offset().left + ($(this).width() / 2) + 'px')
  });

  self.find( "> li" ).mouseover(function() {
    if(!self.hasClass('slide-selector-menu--selected')){
      self.addClass('slide-selector-menu--selected');
    }
    if(!$(this).hasClass('main-menu__item--hover')){
      $(this).addClass('main-menu__item--hover');
    }
  }).mouseout(function() {
    if(self.hasClass('slide-selector-menu--selected')){
      self.removeClass('slide-selector-menu--selected');
      selector.css('left', selector.attr('data-default-selector-position'))
    }
    if($(this).hasClass('main-menu__item--hover')){
      $(this).removeClass('main-menu__item--hover');
    }
  });

  $(window).load(function () {
    self.find( "> li.main-menu__item--ancestor--active, > li.main-menu__item--active" ).each(function() {
      selector.addClass('slide-selector-menu__selector--active')
      selector.attr('data-default-selector-position', $(this).offset().left + ($(this).width() / 2) + 'px')
      selector.css('left', selector.attr('data-default-selector-position'))
    });
  });

  $(window).resize(function() {
    self.find( "> li.main-menu__item--ancestor--active, > li.main-menu__item--active" ).each(function() {
      selector.attr('data-default-selector-position', $(this).offset().left + ($(this).width() / 2) + 'px')
      selector.css('left', selector.attr('data-default-selector-position'))
    });
  });

  return function() {
    return self
  }()
};
